/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'out': {
    width: 21,
    height: 20,
    viewBox: '0 0 21 20',
    data: '<path pid="0" d="M20.808 9.479l-3.5-4.166A.891.891 0 0 0 16.625 5a.9.9 0 0 0-.289.047.836.836 0 0 0-.585.786v2.5h-7a1.668 1.668 0 1 0 0 3.333h7v2.5a.837.837 0 0 0 .585.786.9.9 0 0 0 .289.047.891.891 0 0 0 .684-.313l3.5-4.167a.8.8 0 0 0 0-1.041zm-8.558 7.188H5.236A1.7 1.7 0 0 1 3.5 15V5v-.013a1.7 1.7 0 0 1 1.751-1.654h7a1.668 1.668 0 1 0 0-3.333H3.5A3.419 3.419 0 0 0 0 3.333v13.334A3.42 3.42 0 0 0 3.5 20h8.75a1.668 1.668 0 1 0 0-3.333zm0 0" _fill="#757e8d" fill-rule="evenodd"/>'
  }
})
